import { Company } from './../../../shared/models/companies';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgForm, FormBuilder, FormGroup } from '@angular/forms';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { Program } from 'src/app/shared/models/programs';
import { User } from 'src/app/shared/models/users';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Level } from '../../../shared/enums/level.enum';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class DispersionFormComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  newDispersion: Dispersion;
  programs: any;
  companies: Company[]=[];
  _idCompany:string;
  _idProgram:string;
  _companyName:string;
  uploadForm: FormGroup;
  enable_upload_users_excel_dispersion :  boolean = false;

  title = 'XlsRead';
  file:File
  arrayBuffer:any
  filelist:any
  udta: any;

  cdata = null;
  // recurrance: any = {};
  dispersionTypeIds = [
    { name: 'Inmediata', id: 1 },
    { name: 'Programada', id: 2 },
    // { name: 'Recurrente', id: 3 },
  ]
  dispersionRepeat = [
    { name: 'Una vez al mes', id: 1 },
    { name: 'Cada 15 dias', id: 2 },
    { name: 'Una vez a la semana', id: 3 },
  ];
  tempBeneficiaries: any = [];
  amountOfDispersions: number = 0;
  popupVisible = false;
  selectedProgram: Program;
  tempDateScheduled: any;
  // Variables para despliegue en columna de detalles
  // dispersionTypeName: any;
  minDate = new Date();
  cdta: any;
  usdt: any;
  id_companies_list: any[]=[];
  companies_broker : Company[]=[];
  visible_list_companies=false;

  constructor(
    private utilitiesService: UtilitiesService,
    private companiesService: CompaniesService,
    private usersService: UsersService,
    private router: Router,
    private dispersionsService: DispersionsService,
    private programsService: ProgramsService,
  ) {
    //this.programs = this.cdata.programs;
    //this.cdata = this.utilitiesService.getCompanyData();
  }

  ngOnInit() {
    this.usdt = this.utilitiesService.getUserData();
    console.log(this.usdt.level);
    switch (this.usdt.level) {
      case Level.CompanyAdmin:
        this.visible_list_companies=true;
        this.newDispersion = new Dispersion();
        this.newDispersion.dateCreated = this.utilitiesService.dateToNumber(new Date());
        this.newDispersion.beneficiaries = [];
        this.udta = this.utilitiesService.getUserData();
        this.cdata = this.utilitiesService.getCompanyData();
        this.programs = this.cdata.programs;
        this._idCompany=this.cdata.id;
        this._companyName = this.cdata.companyName;
        this.companiesService.getCompanies().subscribe(companies => {
          this.companies = companies.filter(company => company.id ==  this.usdt.companyId);
        });
      break;
      case Level.ihunterSuperUser:
        this.visible_list_companies=true;
        this.companiesService.getCompanies().subscribe(companies => {
          this.companies = companies;
        });
        this.newDispersion = new Dispersion();
        this.newDispersion.dateCreated = this.utilitiesService.dateToNumber(new Date());
        this.newDispersion.beneficiaries = [];
        this.udta = this.utilitiesService.getUserData();
        this.cdata = this.utilitiesService.getCompanyData();
        this.programs = this.cdata.programs;
        this._idCompany=this.cdata.id;
        this._companyName = this.cdata.companyName;
      break;
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
      case Level.CompanyUser:
        this.companiesService.getCompanies().subscribe(companies => {
          this.companies = companies;
        });
        this.newDispersion = new Dispersion();
        this.newDispersion.dateCreated = this.utilitiesService.dateToNumber(new Date());
        this.newDispersion.beneficiaries = [];
        this.udta = this.utilitiesService.getUserData();
        this.cdata = this.utilitiesService.getCompanyData();
        this.programs = this.cdata.programs;
        this._idCompany=this.cdata.id;
        this._companyName = this.cdata.companyName;
      case Level.Broker:
        this.companiesService.getCompanies().subscribe(companies => {
          this.companies_broker = companies;
          if (this.usdt.companyList) {
            this.visible_list_companies=true;
            this.usdt.companyList.forEach(company => {
              this.id_companies_list.push(company.id.trim());
            });
          }
          this.companies = this.companies_broker.filter(company => this.id_companies_list.includes(company.id));
        });
        this.newDispersion = new Dispersion();
        this.newDispersion.dateCreated = this.utilitiesService.dateToNumber(new Date());
        this.newDispersion.beneficiaries = [];
        //this.udta = this.utilitiesService.getUserData();
        /*this.cdata = this.utilitiesService.getCompanyData();
        this.programs = this.cdata.programs;
        this._idCompany=this.cdata.id;
        this._companyName = this.cdata.companyName;*/
        default:
          break;
    }
  }

  checkProgram(idProgram) {
    this.tempBeneficiaries = [];
    const tempProgName = this.programs.filter(program => program.programId === this.newDispersion.programId);
    this.newDispersion.programName = tempProgName[0].programName;
    this._subscriptions.push(
      this.programsService.getProgram(idProgram).subscribe(program => {
        this.selectedProgram = program;
      })
    );
    this._idProgram = idProgram;
    this.enable_upload_users_excel_dispersion=true;
  }

  checkCompany(idCompany){
    let companychange =_.filter(this.companies, ['id', idCompany]);;
    this.programs = companychange[0].programs;
    this._idCompany=idCompany;
    this._companyName = companychange[0].companyName;
  }

  checkType() {
    // console.log(this.newDispersion.programId);
    this.tempBeneficiaries = [];
    const tempDispType = this.dispersionTypeIds.filter(type => type.id === this.newDispersion.dispersionTypeId);
    this.newDispersion.dispersionTypeName = tempDispType[0].name;
  }


  checkRecurrance(e) {
    // console.log(e);
    this.tempBeneficiaries = [];
    const occurrObj = this.dispersionRepeat.filter(ocurrance => ocurrance.id === e);
    this.newDispersion.recurrance.name = occurrObj[0].name;
    // console.log(this.newDispersion);
  }

  onFormSubmit(data) {
    if (data.validationGroup.validate().isValid) {
      // console.log('OKKKKKKKK');
    }
  }

  getBeneficiaries(data) {
    this.tempBeneficiaries = [];
    if (data.validationGroup.validate().isValid) {
      const cdata = this.utilitiesService.getCompanyData();
      const queryData: any = {};
      queryData.idProgram = this._idProgram;
      queryData.companyId = this._idCompany;
      this._subscriptions.push(
        this.usersService.getBeneficiaries(queryData).subscribe(data => {
          const tempBeneficiaries = data.users;
          
          tempBeneficiaries.forEach(user => {
            const tempUsr: any = {};
            tempUsr.employeeId = user.id;
            tempUsr.middleName = user.middleName;
            tempUsr.employeeName = user.name;
            tempUsr.employeeLastName = user.lastName;
            tempUsr.employeeSecondLastName = user.secondLastName;
            const currentUser  = new User(user);
            currentUser.programs.forEach(function (value){
              if(value.hasOwnProperty('card')){
                if(value.programId==queryData.idProgram){
                  tempUsr.cardNumber = value.card.cardNumber;
                  tempUsr.cardParsed = currentUser.cardParsed();
                }
              }
            });
            tempUsr.amount = 0;
            tempUsr.status = null;
            tempUsr.transactionId = null;
            tempUsr.transactionDate = null;
            tempUsr.transactionSchedule = null;
            if(tempUsr.cardNumber!=null){
              this.tempBeneficiaries.push(tempUsr);
            }
          });
        })
      );
    }
  }

  fileupload(event) {
    this.file= event.target.files[0];     
    let fileReader = new FileReader();    
    fileReader.readAsArrayBuffer(this.file);     
    fileReader.onload = (e) => {    
        this.arrayBuffer = fileReader.result;    
        var data = new Uint8Array(this.arrayBuffer);    
        var arr = new Array();    
        for(var i = 0; i != data.length; ++i){
          arr[i] = String.fromCharCode(data[i]);  
        } 
        var bstr = arr.join("");    
        var workbook = XLSX.read(bstr, {type:"binary"});    
        var first_sheet_name = workbook.SheetNames[0];    
        var worksheet = workbook.Sheets[first_sheet_name];     
        var arraylist = XLSX.utils.sheet_to_json(worksheet,{raw:true});     
        this.filelist = [];
        // arraylist.pop();
        arraylist.forEach(element => {
          const userObjFilter = this.tempBeneficiaries.filter(beneficiarie => beneficiarie.employeeId === element['id']);
          const userObj = userObjFilter;
          userObj[0].amount = element['Monto a dispersar'];
          this.newDispersion.dispersionAmount += element['Monto a dispersar'];
          this.newDispersion.beneficiaries.push(userObj[0]);
        });
        console.log('Detail dispersion: ',this.newDispersion);
        // ******************  CALCULO DE MONTOS, FEES, IVA **********************
        this.amountOfDispersions = this.newDispersion.beneficiaries.length;
        this.newDispersion.fees = this.newDispersion.dispersionAmount * this.selectedProgram.companyCosts.dispersionCost;
        this.newDispersion.tax = (this.newDispersion.fees) * .16;
        this.newDispersion.granTotal = this.newDispersion.dispersionAmount + this.newDispersion.fees + this.newDispersion.tax;
        // ********** valores adicionales al objeto de la dispersion.
        this.newDispersion.companyId = this._idCompany;
        this.newDispersion.companyName = this._companyName;
        if (!this.newDispersion.dateScheduled) {
          this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(new Date());
        }
        if (this.tempDateScheduled) {
          this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(this.tempDateScheduled);
        }
        this.popupVisible = true;
      
    } 
  };

  onSubmitFileCsv() {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('profile').value);
    formData.append('idCompany', this.cdta.id);
    this.usersService.uploadUsersCsv(formData).subscribe(res => {
      this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
    });
    location.reload();
  }

  onSaving(data) {
    // console.log('salvamos', data);
    data.changes.forEach(element => {
      const userObj = this.tempBeneficiaries.filter(user => user.employeeId === element.key);
      userObj[0].amount = element.data;
      this.newDispersion.dispersionAmount += element.data.amount;
      this.newDispersion.beneficiaries.push(userObj[0]);
    });
    // ******************  CALCULO DE MONTOS, FEES, IVA **********************
    this.amountOfDispersions = this.newDispersion.beneficiaries.length;
    this.newDispersion.fees = this.newDispersion.dispersionAmount * this.selectedProgram.companyCosts.dispersionCost;
    this.newDispersion.tax = (this.newDispersion.fees) * .16;
    this.newDispersion.granTotal = this.newDispersion.dispersionAmount + this.newDispersion.fees + this.newDispersion.tax;
    // ********** valores adicionales al objeto de la dispersion.
    this.newDispersion.companyId = this._idCompany;
    this.newDispersion.companyName = this._companyName;
    if (!this.newDispersion.dateScheduled) {
      this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(new Date());
    }
    if (this.tempDateScheduled) {
      this.newDispersion.dateScheduled = this.utilitiesService.dateToNumber(this.tempDateScheduled);
    }
    this.popupVisible = true;
  }


  confirmDispersion(){
    this.popupVisible = true;
  }

  executeDispersion() {
    this.dispersionsService.newDispersion(this.newDispersion).then(data => {
      this.dispersionsService.sendNotificationNewDispersion(this.newDispersion).subscribe( res => {
        this.utilitiesService.notifyMeAndRedirect('Dispersión ejecutada exitosamennte', 'success', '/dash/dispersions');
      });
    }).catch(error => {
      this.utilitiesService.notifyMe(error, 'error');
    });
  }

  cancelDispersion() {
    this.popupVisible = true;
    this.enable_upload_users_excel_dispersion=false;
    this.newDispersion = new Dispersion();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
